import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  loading: boolean;
  reports: Report[];
}


import { ref, computed, watch } from 'vue';
import sortBy from 'lodash/sortBy';

import { api } from '@api';
import { Report } from '@models';
import { formatReportDistance, formatReportSpeed } from '@utils/reports';

// import RadialProgressBar from 'vue-radial-progress';
import RadialProgressBar from '@components/RadialProgressBar';
import CardLoadable from '@components/Cards/CardLoadable.vue';
import DisplayTextDate from '@components/Display/DisplayTextDate.vue';

declare module 'vue/types/vue' {
  export interface Vue {
    CardMostRecentFlightInfo: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'CardMostRecentFlightInfo' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    loading: { type: Boolean },
    reports: null
  },
  setup(__props: any) {

const props = __props as {
  loading: boolean;
  reports: Report[];
};

/**
 * `CardMostRecentFlightInfo` component properties.
 */


// loading = true;
const loadingReport = ref(true);
const report = ref<Report | null>(null);

watch(
  () => props.reports,
  (reports) => {
    report.value = null;

    const reportId = sortBy(reports, ['createdAt']).pop()?.id;

    if (reportId) {
      void loadReports(reportId);
    } else {
      loadingReport.value = false;
    }
  },
  { immediate: true },
);

/** ... */
const topSpeedDisplay = computed(() => {
  return report.value ? formatReportSpeed(report.value.topSpeed) : null;
});

/** ... */
const averageSpeedDisplay = computed(() => {
  return report.value ? formatReportSpeed(report.value.averageSpeed) : null;
});

/** ... */
const maxAltitudeDisplay = computed(() => {
  return report.value ? formatReportDistance(report.value.maxAltitude) : null;
});

/** ... */
const averageAltitudeDisplay = computed(() => {
  return report.value
    ? formatReportDistance(report.value.averageAltitude)
    : null;
});

/** ... */
const items = computed(() => {
  if (!report.value) return [];

  return [
    {
      key: 'topSpeed',
      label: 'Top Speed',
      value: topSpeedDisplay.value,
    },
    {
      key: 'averageSpeed',
      label: 'Average Speed',
      value: averageSpeedDisplay.value,
    },
    {
      key: 'maxAltitude',
      label: 'Max Altitude',
      value: maxAltitudeDisplay.value,
    },
    {
      key: 'averageAltitude',
      label: 'Average Altitude',
      value: averageAltitudeDisplay.value,
    },
  ];
});

/** ... */
const displayModuleName = computed(() => {
  return report.value?.module?.name ?? '--';
});

/** ... */
const displaySceneName = computed(() => {
  return report.value?.scene?.name ?? '--';
});

/**
 * ...
 *
 * @param reportId ...
 */
async function loadReports(reportId: Report['id']) {
  loadingReport.value = true;

  try {
    report.value = await api.reports.get({ reportId });
  } catch {
    //
  }

  loadingReport.value = false;
}

return { __sfc: true,props, loadingReport, report, topSpeedDisplay, averageSpeedDisplay, maxAltitudeDisplay, averageAltitudeDisplay, items, displayModuleName, displaySceneName, loadReports, RadialProgressBar, CardLoadable, DisplayTextDate }
}

})